import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import TreeView from "../../../../../components/treeView/taxonomy";
import { getLoggedInUser, getProductVariant } from "../../../../../../utilities";
import { actionSuccess, showLoader, hideLoader, actionError, showMessage } from "../../../../../../middleware/actions/utilityAction";
import { processingSubmit } from "../../../../../../middleware/services/cmsApi";
import {
  fetchCompanyTaxonomy,
  saveCompanyTaxonomy,
  deleteCompanyTaxonomy,
  fetchSingleCompany,
  saveCompanyValueChain,
  fetchCompanyKia,
  deleteCompanyKia,
  saveCompanyKiaTaxonomy,
  deleteManyCompanyTechnology,
  deleteManyCompanyValueChain,
} from "../../../../../../middleware/services/companyApi";
import { fetchProductBasic } from "../../../../../../middleware/services/productApi";
import { showAlertBox } from "../../../../../../middleware/actions/alertBoxAction";
import "../../../../../components/popup/index.scss";
import { COMMON_ACCESS_ACTION } from "../../../../../../constants";
import PropTypes from "prop-types";

const TaxomonyUI = (props) => {
  const [clickSaveSubmit, setClickSaveSubmit] = useState(false);
  const [updateClick, setUpdateClick] = useState(false);
  /* Common access */
  const accessActionAdd = props?.interfaceActionAccessTaxonomy?.includes(COMMON_ACCESS_ACTION.ADD);
  const accessActionDelete = props?.interfaceActionAccessTaxonomy?.includes(COMMON_ACCESS_ACTION.DELETE);
  const accessActionSubmit = props?.interfaceActionAccessTaxonomy?.includes(COMMON_ACCESS_ACTION.SUBMIT);

  const history = useHistory();
  const dispatch = useDispatch();
  const companyId = props.companyId;
  const loggedInUser = getLoggedInUser();
  const [saveTreeData, setSaveTreeData] = useState(false);
  const [saveTreeDataAction, setSaveTreeDataAction] = useState(false);
  const [companyProducts, setCompanyProducts] = useState([]);
  const cancelPath = props.path === "/processing/company/:companyId/edit" ? "/processing/company" : "/company";
  const [submitStatus, setSubmitStatus] = useState(false);

  const handleSubmit = (selectedTech, checkValues, tab, callback, kiaFlag) => {
    if (cancelPath === "/processing/company" || props.path === "/company/:companyId/edit" || props.path === "/data-qc/company/:companyId/edit") {
      if (companyProducts?.length) {
        //submitting logic
        saveTaxonomyProcessing(selectedTech, tab);
      } else {
        if (checkValues.length || Object.keys(checkValues).length) {
          //save and submit logic
          if (tab == "technology") {
            saveTaxonomy(selectedTech, checkValues, callback);
          }
          if (tab == "kia") {
            saveKiaTagging(selectedTech, checkValues, tab, callback);
          }
          if (tab == "valueChain") {
            handleSaveValueChain(selectedTech, checkValues, callback);
          }
        } else {
          dispatch(showMessage("Please select Taxonomy...!"));
          setSubmitStatus(false);
        }
      }
    }
  };

  const saveTaxonomy = (selectedTech, taxonomyIds, callback) => {
    if (selectedTech) {
      deleteCompanyTaxonomy(companyId, selectedTech)
        .then(() => {
          if (taxonomyIds.length > 0) {
            try {
              const response = saveCompanyTaxonomy(companyId, taxonomyIds);
              response
                .then((response) => {
                  callback();
                  dispatch(actionSuccess("Taxonomy Updated Successfully"));
                  if (submitStatus) {
                    setTimeout(() => {
                      saveTaxonomyProcessing(selectedTech, "technology");
                    }, [2000]);
                  }
                })
                .catch((e) => {
                  dispatch(actionError("Something Went Wrong...!"));
                  setSubmitStatus(false);
                });
            } catch (e) {
              dispatch(actionError("Something Went Wrong...!"));
              setSubmitStatus(false);
            }
          } else {
            dispatch(actionError("Please select taxonomy"));
            setSaveTreeData(false);
            setSaveTreeDataAction(false);
            setClickSaveSubmit(false);
            setSubmitStatus(false);
          }
        })
        .catch((e) => {
          dispatch(hideLoader());
          dispatch(actionError("Something Went Wrong...!"));
        });
    }
    setSaveTreeData(false);
    setSaveTreeDataAction(false);
  };

  const saveTaxonomyProcessing = (selectedTech, tab) => {
    const payload = {
      userId: loggedInUser._id,
      dtId: selectedTech,
    };
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await processingSubmit(companyId, tab, payload)
            .then((response) => {
              dispatch(actionSuccess(`Company successfully Saved & Submitted`));
            })
            .catch((err) => {
              dispatch(actionError(err?.data?.message || "Something went wrong"));
              setSubmitStatus(false);
            });
        },
        cancelCallback: () => {
          setSubmitStatus(false);
        },
        okText: "Submit",
        cancelText: "Cancel",
        content: "Are you sure you want to submit ?",
        title: "dialogAlertCss",
      })
    );
    setClickSaveSubmit(false);
    setUpdateClick(false);
    setSaveTreeData(false);
    setSaveTreeDataAction(false);
    setSubmitStatus(false);
  };
  /*
	@param selectedIndustry : Selected Industry to save their respective kia
	@param kiaIds : Selected KiaIds
	@param callback : use for re-render tree component
	
	@description : Save kia for respective industry
				1.Delete all kia for selected industry
				2.Save all kia for selected industry
	*/
  const saveKiaTagging = (selectedIndustry, kiaIds, tab, callback) => {
    if (selectedIndustry) {
      dispatch(showLoader());
      deleteCompanyKia(companyId, { industryId: selectedIndustry })
        .then(() => {
          dispatch(hideLoader());
          if (kiaIds.length > 0) {
            dispatch(showLoader());
            try {
              const response = saveCompanyKiaTaxonomy(companyId, {
                taxonomyIds: kiaIds,
              });
              response
                .then((response) => {
                  callback();
                  if (submitStatus) {
                    setTimeout(() => {
                      saveTaxonomyProcessing(selectedIndustry, "kia");
                    }, [2000]);
                  }
                  dispatch(hideLoader());
                  dispatch(actionSuccess("KIA Updated Successfully"));
                })
                .catch((e) => {
                  dispatch(hideLoader());
                  dispatch(actionError("Something Went Wrong...!"));
                  setSubmitStatus(false);
                });
            } catch (e) {
              dispatch(hideLoader());
              dispatch(actionError("Something Went Wrong...!"));
              setSubmitStatus(false);
            }
          }
        })
        .catch((e) => {
          dispatch(hideLoader());
          dispatch(actionError("Something Went Wrong...!"));
        });
    }
    setClickSaveSubmit(false);
    setUpdateClick(false);
    setSaveTreeData(false);
    setSaveTreeDataAction(false);
  };
  const handleSaveValueChain = (selectedTech, checkValues, callback1, callback2) => {
    dispatch(showLoader());
    const response = saveCompanyValueChain(companyId, { ...checkValues });
    response
      .then((response) => {
        dispatch(hideLoader());
        callback1();
        // callback2();
        if (submitStatus) {
          setTimeout(() => {
            saveTaxonomyProcessing(selectedTech, "valueChain");
          }, [2000]);
        }
        dispatch(actionSuccess("Value Chain Updated Successfully"));
      })
      .catch((e) => {
        dispatch(hideLoader());
        dispatch(actionError("Something Went Wrong...!"));
        setSubmitStatus(false);
      });
    setClickSaveSubmit(false);
    setUpdateClick(false);
    setSaveTreeData(false);
    setSaveTreeDataAction(false);
  };
  const fetchTagging = () => {
    fetchCompanyTaxonomy(companyId).then((res) => {});
  };
  const fetchProductBasicWithCompany = () => {
    let defaultFilter = [["productCompany.companyId", "eq", props.companyId]];
    const productVariant = getProductVariant();
    if (productVariant) defaultFilter.push(["productVariant.productName", "eq", productVariant]);
    let params = {};
    params.fields = ["productCompany", "productName"];
    params.filters = [...defaultFilter];
    fetchProductBasic({ ...params })
      .then((res) => {
        if (res) {
          const { data = [] } = res.data;
          setCompanyProducts([...data]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const deleteTechnology = (checkedTrends, callback) => {
    deleteManyCompanyTechnology(companyId, checkedTrends)
      .then((res) => {
        callback();
        dispatch(actionSuccess("Taxonomy deleted Successfully"));
      })
      .catch((err) => {
        dispatch(actionError("Something Went Wrong...!"));
      });
  };
  const deleteKia = (checkedTrends, callback) => {
    let payload = { taxonomyIds: checkedTrends };
    deleteCompanyKia(companyId, payload)
      .then(() => {
        callback();
        dispatch(actionSuccess("Taxonomy deleted Successfully"));
      })
      .catch((err) => {
        dispatch(actionError("Something Went Wrong...!"));
      });
  };

  const deleteValueChain = (payload, callback) => {
    deleteManyCompanyValueChain(companyId, payload)
      .then(() => {
        callback();
        dispatch(actionSuccess("Taxonomy deleted Successfully"));
      })
      .catch((err) => {
        dispatch(actionError("Something Went Wrong...!"));
      });
  };

  useEffect(() => {
    fetchTagging();
    fetchProductBasicWithCompany();
  }, []);

  return (
    <div style={{ backgroundColor: "#f2f2f2", overflow: "hidden" }}>
      <TreeView
        handleSave={saveTaxonomy}
        saveTreeData={saveTreeData}
        contentId={companyId}
        fetchContentTagging={fetchCompanyTaxonomy}
        fetchContentData={fetchSingleCompany}
        loadOtherTagInfo={props.loadOtherTagInfo}
        fetchKiaTagging={fetchCompanyKia}
        handleSaveKIA={saveKiaTagging}
        handleSaveValueChain={handleSaveValueChain}
        contentType="company"
        deleteTechnology={deleteTechnology}
        isDelete={companyProducts?.length ? false : true}
        setSaveTreeData={setSaveTreeData}
        deleteKia={deleteKia}
        deleteValueChain={deleteValueChain}
        accessPermissionTaxonomyDelete={accessActionDelete}
        accessPermissionTaxonomy={accessActionAdd}
        handleSubmit={handleSubmit}
        submitStatus={submitStatus}
        setSubmitStatus={setSubmitStatus}
        saveTrendTreeData={props.saveTrendTreeData}
        setSaveTrendTreeData={props.setSaveTrendTreeData}
      />
      <div className="form-submit-box">
        <div className="footer-layout">
          {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
            <button
              type="button"
              className="btn btn-outline-dark company-button"
              onClick={() => {
                (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                  (props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex - 1));
              }}
            >
              Previous
            </button>
          ) : null}
        </div>
        <div className="footer-layout">
          <button type="button" className="btn btn-outline-dark company-button" onClick={() => history.push(`${cancelPath}`)}>
            Cancel
          </button>
          {accessActionSubmit ? (
            <>
              {cancelPath === "/processing/company" ? (
                <button
                  type="button"
                  className="btn btn-primary company-button"
                  onClick={() => {
                    if (companyProducts.length < 1) {
                      clickSaveSubmit ? setClickSaveSubmit(false) : setClickSaveSubmit(true);
                    } else {
                      setSaveTreeDataAction("saveAndSubmit");
                    }
                  }}
                >
                  Submit
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary company-button"
                  onClick={() => {
                    setSubmitStatus(true);
                  }}
                >
                  Submit
                </button>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
TaxomonyUI.propTypes = {
  interfaceActionAccess: PropTypes.bool,
  companyId: PropTypes.string,
  path: PropTypes.string,
  loadOtherTagInfo: PropTypes.func,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
};
export default TaxomonyUI;
